import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export function errMsg(e, fallback = "Something went wrong. Please try again.") {
  const d = e?.response?.data?.detail;
  if (!d) return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  return d.msg || fallback;
}

export function cld(url, t = "w_1000,q_auto,f_auto") {
  if (!url || !url.includes("res.cloudinary.com") || !url.includes("/upload/")) return url;
  return url.replace("/upload/", `/upload/${t}/`);
}

const fmt = new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" });
export const money = (n) => fmt.format(n || 0);

export const CATEGORY_LABEL = {
  Original: "Original painting",
  "Canvas Print": "Canvas print",
  "Fine Art Poster": "Fine art poster",
};

export function dims(p) {
  const d = p?.dimensions;
  if (!d?.width || !d?.height) return "";
  const imp = p.dimensionsImperial?.width ? ` · ${p.dimensionsImperial.width} × ${p.dimensionsImperial.height} in` : "";
  return `${d.width} × ${d.height} ${d.unit || "cm"}${imp}`;
}

export const fmtDate = (s) => (s ? new Date(s).toLocaleDateString("en-AU", { day: "numeric", month: "short", year: "numeric" }) : "—");
